import { query_customer_remain_money_list } from '@/api/mjstat-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/mjstat/mjstat-customerremainmoney-config';

import { reactive } from 'vue';
import moment from 'moment';
import { toFixed0 } from '@/utils/function';

const None = null;
const True = true;
const False = false;

export default () => {
  const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
  const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店

  const search_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'inline',
    },
    fields: [
      // {
      //   type: 'remotemodal',
      //   name: 'customer_id',
      //   label: '会员姓名',
      //   disabled: false,
      //   placeholder: '请选择会员姓名',
      //   datasourceType: 'remote',
      //   mode: 'default',
      //   allowClear: true,
      //   modalType: 'mjstore-customer',
      // },
      {
        type: 'input',
        name: 'customer_code',
        label: '会员编号',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写会员编号',
      },
      {
        type: 'input',
        name: 'customer_name',
        label: '会员姓名',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写会员姓名',
      },
      {
        type: 'remoteselect',
        name: 'shop_id',
        label: '会籍门店',
        disabled: false,
        placeholder: '请选择会籍门店',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-shop',
      },
      {
        type: 'datepicker',
        name: 'query_date',
        label: '时间节点',
        disabled: false,
        allowClear: true,
        inputType: 'number',
        defaultValue: '',
        valueFormat: 'YYYY-MM-DD',
        format: 'YYYY-MM-DD',
        showTime: false,
        placeholder: '请填写时间节点',
      },
    ],
    rules: {
      query_date: [{ required: true, message: '请填写时间节点' }],
    },
    model: reactive({
      org_id: current_org?.id,
      is_active: true,
      shop_id: null,
      customer_code: null,
      customer_id: null,
      customer_name: null,
      query_date: moment().format('YYYY-MM-DD'),
    }),
  };
  const search_options = {};

  const edit_model_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'horizontal',
      col: config.creatCol,
    },
    fields: [],
    rules: {},
    model: reactive({
      org_id: current_org?.id,
      is_active: true,
    }),
  };
  const edit_model_config_options = {};

  const update_model_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'horizontal',
      col: config.creatCol,
    },
    fields: [],
    rules: {},
    model: reactive({
      org_id: current_org?.id,
      is_active: true,
    }),
  };
  const update_model_config_options = {};

  const titleList = {
    title: '余额余项额',
    addModalTitle: '新建等级变动记录',
    updateTitle: '修改等级变动记录',
    is_create: false, // 是否有【新建】按钮
    is_update: false, // 是否有【修改】按钮
    is_remove: false, // 是否有【删除】按钮
    is_recover: false, // 是否有【恢复】按钮
  };

  const api_fields: Record = {
    update: {
      id: 'id',
    },
    delete: {
      id: 'id',
    },
    recover: {
      id: 'id',
    },
    updateData: {
      org_id: 'org_id',
      id: 'id',
    },
  };

  const baseColumns: TableColumn[] = [
    {
      title: '序号',
      dataIndex: 'index',
      width: 50,
      fixed: 'left',
    },
    {
      title: '会员编号',
      width: 140,
      dataIndex: 'code',
      checked: true,
      fixed: 'left',
    },
    {
      title: '会员姓名',
      width: 100,
      dataIndex: 'name',
      checked: true,
      fixed: 'left',
    },
    {
      title: '会员门店',
      width: 150,
      dataIndex: 'shop_name',
      checked: true,
      fixed: 'left',
    },
    {
      title: '充值总余额',
      width: 120,
      dataIndex: 'customer_cz',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '返利总余额',
      width: 120,
      dataIndex: 'customer_fl',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '直接返利总余额',
      width: 120,
      dataIndex: 'customer_zjfl',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '充值余额',
      width: 120,
      dataIndex: 'cz',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '充值返利余额',
      width: 120,
      dataIndex: 'fl',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '下单充值余额',
      width: 120,
      dataIndex: 'order_cz',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '下单返利余额',
      width: 120,
      dataIndex: 'order_fl',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '下单直接返利余额',
      width: 130,
      dataIndex: 'order_zjfl',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '购卡充值余额',
      width: 120,
      dataIndex: 'card_cz',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '购卡返利余额',
      width: 120,
      dataIndex: 'card_fl',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '购卡直接返利余额',
      width: 130,
      dataIndex: 'card_zjfl',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
  ];
  const newSlotList: any = [];
  Object.assign(newSlotList, slotList);
  newSlotList.push({
    type: 'custom',
    slotName: 'is_active',
    field_true: '可用',
    field_false: '作废',
  });

  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_customer_remain_money_list,
    addData: None,
    updateData: None,
    removeData: None,
    recoverData: None,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
